import { injectStore } from "../../../../stores/injectStore";
import { Store } from "../../../../stores/Store";
import { observer } from "mobx-react-lite";
import React, { RefObject, useContext, useState } from "react";
import { getPortalsForUser } from "./api/getPortalsForUser";
import { Error } from "./generics/Error/Error";
import { PortalContext, portalsLoaded, portalsLoadFailed } from "./state";
import { asyncAction } from "./utils/asyncAction";

type Props = {
  store: Store;
  ref?: RefObject<HTMLDivElement | null>;
};

const ErrorMessageUnwrapped: React.FC<Props> = observer((props) => {
  const { dispatch } = useContext(PortalContext);
  const [isLoading, setLoading] = useState(false);

  const retry = (): void => {
    if (isLoading) {
      return;
    }

    const promise = getPortalsForUser();

    asyncAction({
      dispatch,
      promise,
      doneAction: portalsLoaded,
      failAction: portalsLoadFailed,
    });

    setLoading(true);
    promise.catch(() => {
      setLoading(false);
    });
  };

  return <Error ref={props.ref} isLoading={isLoading} onRetry={retry} />;
});

export const ErrorMessage = injectStore(
  (store) => ({
    store,
  }),
  ErrorMessageUnwrapped,
);
